import React from 'react';
import styled, { css } from 'styled-components';
import { Colors } from '@airasia-common/libraries/constants';
import { func } from 'prop-types';
import { layout } from 'styled-system';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import { useHistory } from 'react-router-dom';
import Wrapper from '../Wrapper';
import Row from '../Container/Row';
import Text from '../Text/Text';
import Button from '../Button';
import { BadRequestErrorImage } from '../../utils/statics';
import { navigateToHome } from '../../utils/navigation';

const TitleLabel = styled(Text)`
  font-size: 20px;
  line-height: 26px;
  margin-bottom: 8px;
  text-align: center;
`;

const DescriptionLabel = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 20px;
  text-align: center;
  ${layout}
`;

const imageStyle = css`
  height: 470px;
  width: 100%;
  background-image: url(${BadRequestErrorImage});
  background-size: auto;
  overflow: hidden;
  margin-bottom: 40px;
`;

const StyledImage = styled.div`
  ${imageStyle}
  ${layout}
`;

const StyledImageMW = styled.div`
  ${imageStyle};
  ${layout};
  background-position: right 35% bottom 65%;
`;

const ActionButton = styled(Button)`
  width: 140px;
  height: 48px;
  margin: 8px;
`;

ActionButton.displayName = 'ActionButton';

const GenericError = ({ goHomeHandler, goBackHandler }) => {
  const history = useHistory();

  const navigateBack = () => {
    history.goBack();
  };

  return (
    <Wrapper
      alignItems="center"
      display="flex"
      flexDirection="column"
      background={Colors.primaryWhite}
    >
      <StyledImage marginBottom={40} display={['none', 'block']} />
      <StyledImageMW marginBottom={40} display={['block', 'none']} />

      <TitleLabel color={'darkBlack'}>
        {translate('badRequest.title')}
      </TitleLabel>
      <DescriptionLabel
        color={'greyDark'}
        marginX={4}
        display={['none', 'block']}
      >
        {translate('badRequest.description')}
      </DescriptionLabel>
      <DescriptionLabel
        color={'greyDark'}
        width="330px"
        display={['block', 'none']}
      >
        {translate('badRequest.description')}
      </DescriptionLabel>
      <Row>
        <ActionButton secondary onClick={goHomeHandler || navigateToHome}>
          {translate('badRequest.goHomeTitle')}
        </ActionButton>
        <ActionButton secondary onClick={goBackHandler || navigateBack}>
          {translate('badRequest.goBackTitle')}
        </ActionButton>
      </Row>
    </Wrapper>
  );
};

GenericError.propTypes = {
  goHomeHandler: func,
  goBackHandler: func,
};

export default GenericError;
